import { render, staticRenderFns } from "./visitadotrilha.vue?vue&type=template&id=6f2951d1"
import script from "./visitadotrilha.vue?vue&type=script&lang=js"
export * from "./visitadotrilha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports